import CompanyLogo from '@/components/company/CompanyLogo';
import { SearchForm } from '@/components/ui/SearchForm';
import Image from 'next/image';

export default function CompanyHero({ company, title, subtitle }) {
	const formAction = company.transportType === 'train' ? 'train' : 'tickets';
	const backgroundUrl = `${process.env.NEXT_PUBLIC_AWS_S3_BUCKET}/companies/background/${company.id}.png`;
	const backgroundFallbackUrl = `${process.env.NEXT_PUBLIC_AWS_S3_BUCKET}/companies/background/${company.transportType}.png`;

	return (
		<div className="relative md:py-10">
			<Image
				alt={`${company.name} background`}
				src={backgroundUrl}
				priority={false}
				fill
				onError={(e) => {
					e.target.id = backgroundFallbackUrl;
					e.target.srcset = backgroundFallbackUrl;
				}}
				className="absolute inset-0 -z-10 hidden h-full w-full object-cover md:block"
			/>

			<div className="mx-auto max-w-7xl lg:px-8">
				<div className="md:max-w-(--breakpoint-md) relative bg-white px-4 pb-4 pt-2 md:mx-auto md:rounded-3xl md:px-6 md:py-6 md:shadow-xl md:ring-1 md:ring-gray-300 lg:ml-0 lg:mr-auto lg:py-4">
					<div className="mb-2 md:mx-0 md:mb-4">
						<CompanyLogo
							key={company.id}
							companyId={company.id}
							priority={true}
							alt={company.name}
							title={company.name}
							width={250}
							height={50}
							onError={(e) => {
								e.target.classList.add('hidden');
							}}
							className="max-w-52 mx-auto h-[50px] w-auto object-contain md:mx-0 md:object-left"
						/>
					</div>
					<h1 className="text-center text-lg font-bold leading-tight tracking-tight text-gray-900 md:text-left lg:text-3xl">
						{title}
					</h1>
					<h2 className="hidden text-base leading-tight text-gray-600 md:inline-block lg:text-lg">
						{subtitle}
					</h2>
					<SearchForm
						action={formAction}
						filterOptions={{
							company: company.name,
						}}
						dateEnabled={false}
						className="mt-4 w-full"
					/>
				</div>
			</div>
		</div>
	);
}
